import script from "./PointOfSaleMap.vue?vue&type=script&setup=true&lang=js"
export * from "./PointOfSaleMap.vue?vue&type=script&setup=true&lang=js"

import "./PointOfSaleMap.vue?vue&type=style&index=0&id=57ce8e5b&lang=scss"
import "./PointOfSaleMap.vue?vue&type=style&index=1&id=57ce8e5b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ce8e5b"]])

export default __exports__